module.exports = __webpack_public_path__ + "static/media/modis2911.76320b8e.jpg";